import { useEffect, useState } from "react";
import useUser from "../../../../hooks/useUser";

const useVerifyUserName = (userName: string) => {
  const [isAvailable, setIsAvailable] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { handleCheckUsername } = useUser();
  const [isCheckingAvailability, setIsCheckingAvailability] = useState(false);

  useEffect(() => {
    // check if the username is available
    const debouncedTimeout = setTimeout(() => {
      fetchData();
    }, 800);

    return () => clearTimeout(debouncedTimeout);
  }, [userName]);

  const fetchData = async () => {
    try {
      if (userName === "") return;
      setIsCheckingAvailability(true);

      let { data } = await handleCheckUsername(userName);
      setIsCheckingAvailability(false);
      const { message } = data;

      setSuccessMessage(message || "it is available");
      setErrorMessage("");
      setIsAvailable(true);
      return;
    } catch (error: any) {
      setIsCheckingAvailability(false);
      const { message } = error.response.data;
      setIsAvailable(false);
      setErrorMessage(message);
      return;
    }
  };

  return { isAvailable, errorMessage, successMessage, isCheckingAvailability };
};

export default useVerifyUserName;
